import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Card } from '@totalsoft/rocket-ui';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import { useAuthUserData } from 'hooks';
import { CardActionsContainer } from 'components/common/CardStyles';

const InsuranceFlowChecksComponent = ({ onOpenInsuranceFlowRcaChecks, onOpenInsuranceFlowCascoChecks }) => {
  const { t } = useTranslation();
  const { authUser } = useAuthUserData();

  const rightToOpenInsuranceIntegrationCheckForCasco = authUser?.authorizations?.hasRightToOpenInsuranceIntegrationCheckForCasco;
  const rightToOpenInsuranceIntegrationCheckForRca = authUser?.authorizations?.hasRightToOpenInsuranceIntegrationCheckForRca;

  return (
    <>
      {(rightToOpenInsuranceIntegrationCheckForCasco || rightToOpenInsuranceIntegrationCheckForRca) && (
        <Card title={t('Settings.InsuranceIntegrationChecks.Title')} icon={PlaylistAddCheckIcon}>
          <CardActionsContainer>
            {rightToOpenInsuranceIntegrationCheckForRca && (
              <Button id='insuranceFlowChecks_rca' color='primary' onClick={onOpenInsuranceFlowRcaChecks}>
                {t('Settings.InsuranceIntegrationChecks.RcaCheck.Title')}
              </Button>
            )}
            {rightToOpenInsuranceIntegrationCheckForCasco && (
              <Button id='insuranceFlowChecks_casco' color='primary' onClick={onOpenInsuranceFlowCascoChecks}>
                {t('Settings.InsuranceIntegrationChecks.CascoCheck.Title')}
              </Button>
            )}
          </CardActionsContainer>
        </Card>
      )}
    </>
  );
};

InsuranceFlowChecksComponent.propTypes = {
  onOpenInsuranceFlowRcaChecks: PropTypes.func.isRequired,
  onOpenInsuranceFlowCascoChecks: PropTypes.func.isRequired
};

export default InsuranceFlowChecksComponent;
